import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import axios from "../utils/axiosInstance";
import { useToast } from "./ConfirmDialog";
import { io } from "socket.io-client";
import { jsPDF } from "jspdf";

const API = "";
const SOCKET_URL = process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

const Styles = () => (
  <style>{`
.ia-container { max-width: 1200px; margin: 0 auto; }
.ia-header-card {
  background: linear-gradient(135deg, #003366 0%, #004080 100%);
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 20px;
  border-left: 5px solid #FFD700;
  box-shadow: 0 2px 8px rgba(0,51,102,0.2);
}
.ia-header-card h2 { color: #ffffff; font-size: 1.1rem; font-weight: 700; margin: 0; display: flex; align-items: center; gap: 10px; }
.ia-header-card p { color: rgba(255,255,255,0.7); font-size: 0.82rem; margin: 4px 0 0; }
.ia-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
}
.ia-search {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  height: 40px;
}
.ia-search i { color: #94a3b8; font-size: 0.9rem; }
.ia-search input {
  border: none;
  background: none;
  outline: none;
  flex: 1;
  font-size: 0.85rem;
  color: #1e293b;
  font-family: inherit;
}
.ia-search input::placeholder { color: #94a3b8; }
.ia-filter-select {
  padding: 8px 12px;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  font-size: 0.82rem;
  color: #475569;
  background: #ffffff;
  font-family: inherit;
  cursor: pointer;
}
.ia-btn-icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}
.ia-btn-icon:hover { background: #f1f5f9; border-color: #003366; color: #003366; }
.ia-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ia-table-scroll { overflow-x: auto; }
.ia-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.ia-table th {
  text-align: left; padding: 12px 16px;
  font-size: 0.65rem; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.07em;
  border-bottom: 2px solid #e2e8f0;
  background: #f8fafc; white-space: nowrap;
}
.ia-table td { padding: 12px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
.ia-table tbody tr:hover { background: #f0f4f8; }
.ia-table tbody tr:last-child td { border-bottom: none; }
.ia-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}
.ia-empty-state i { font-size: 3rem; color: #cbd5e1; margin-bottom: 16px; display: block; }
.ia-empty-state p { font-size: 0.9rem; margin: 0; }
.ia-status { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; }
.ia-status-sent { background: #d1fae5; color: #065f46; }
.ia-status-pending { background: #fef3c7; color: #b45309; }
.ia-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.ia-page-btn {
  min-width: 34px;
  height: 34px;
  border: 1px solid #d1d9e6;
  background: #ffffff;
  color: #475569;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}
.ia-page-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
.ia-page-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.ia-page-btn.active { background: #003366; color: #ffffff; border-color: #003366; }
.ia-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.78rem;
  color: #64748b;
}
.ia-detail-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ia-detail-header {
  background: #003366;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 3px solid #FFD700;
}
.ia-detail-header i { color: #FFD700; font-size: 1.3rem; }
.ia-detail-header h3 { color: #ffffff; font-size: 1rem; font-weight: 700; margin: 0; }
.ia-detail-body { padding: 20px; }
.ia-field { margin-bottom: 12px; }
.ia-field-label { font-size: 0.72rem; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }
.ia-field-value { font-size: 0.9rem; color: #1e293b; font-weight: 500; margin-top: 2px; }
.signature-preview { max-height: 60px; display: block; margin: 8px auto; background: #fff; border-radius: 4px; padding: 4px; border: 1px solid #e2e8f0; }
@media (max-width: 768px) {
  .ia-table { font-size: 0.75rem; }
  .ia-table th, .ia-table td { padding: 8px 10px; }
}

/* ── Mobile: card-style rows instead of a horizontally-scrolling table ── */
@media (max-width: 640px) {
  .ia-header-card { padding: 16px 18px; }
  .ia-header-card h2 { font-size: 1rem; }
  .ia-controls { flex-direction: column; align-items: stretch; }
  .ia-controls .ia-search { max-width: 100%; }
  .ia-controls .ia-filter-select { width: 100%; }

  .ia-table-scroll { overflow-x: visible; }
  .ia-table, .ia-table tbody, .ia-table tr, .ia-table td { display: block; width: 100%; }
  .ia-table thead { display: none; }
  .ia-table tbody tr {
    margin: 12px; width: auto;
    border: 1px solid #e2e8f0; border-radius: 10px;
    padding: 6px 14px; background: #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }
  .ia-table tbody tr:hover { background: #fff; }
  .ia-table td {
    display: flex; align-items: flex-start; justify-content: space-between;
    gap: 12px; padding: 9px 0; border-bottom: 1px solid #f1f5f9;
    text-align: right; white-space: normal !important;
    max-width: none !important; overflow: visible !important; text-overflow: clip !important;
    word-break: break-word; overflow-wrap: anywhere; min-width: 0;
  }
  .ia-table tr td:last-child { border-bottom: none; }
  .ia-table td::before {
    content: attr(data-label);
    font-weight: 700; color: #64748b; font-size: 0.68rem;
    text-transform: uppercase; letter-spacing: 0.04em;
    text-align: left; flex-shrink: 0; padding-top: 1px;
  }
  .ia-table td[data-label=""]::before { display: none; }
  .ia-table td[colspan] { display: block; text-align: center; }
  .ia-table tbody tr:has(td[colspan]) { padding: 0; border: none; box-shadow: none; background: transparent; }
  .ia-info-bar { flex-wrap: wrap; gap: 6px; }
  .ia-pagination { flex-wrap: wrap; }
}

/* ── GOVERNMENT DOCUMENT STYLES ── */
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&family=Noto+Serif:wght@400;700&display=swap');

.doc-page {
  background: #e8ecf1;
  min-height: 100vh;
  padding: 30px 16px;
  font-family: 'Nunito Sans', system-ui, sans-serif;
}
.doc-paper {
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06);
  padding: 50px 55px 40px;
  margin: 0 auto;
  position: relative;
  font-family: 'Nunito Sans', system-ui, sans-serif;
  color: #1e293b;
  overflow: hidden;
}
.doc-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-30deg);
  font-size: 120px;
  font-weight: 900;
  color: rgba(26,58,92,0.025);
  pointer-events: none;
  white-space: nowrap;
  letter-spacing: 12px;
  text-transform: uppercase;
  z-index: 0;
  font-family: 'Noto Serif', serif;
}
.doc-header {
  text-align: center;
  padding-bottom: 28px;
  border-bottom: 3px solid #1a3a5c;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-header::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #d4a843;
  border-radius: 2px;
}
.doc-header-left { display: inline-block; vertical-align: middle; margin-bottom: 10px; }
.doc-header-left svg { width: 56px; height: 56px; }
.doc-header-center { }
.doc-header-right { position: absolute; top: 0; right: 0; text-align: right; }
.doc-header-republic {
  font-family: 'Noto Serif', serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a3a5c;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  margin: 0 0 4px;
}
.doc-header-ministry {
  font-family: 'Noto Serif', serif;
  font-size: 13px;
  font-weight: 600;
  color: #b8860b;
  text-transform: uppercase;
  margin: 4px 0;
  letter-spacing: 1px;
}
.doc-header-system {
  font-size: 10px;
  font-weight: 500;
  color: #888;
  margin: 2px 0 0;
}
.doc-ref-number {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: #1a3a5c;
  padding: 6px 18px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}
.doc-tracking {
  font-size: 9px;
  color: #999;
  margin-top: 4px;
  letter-spacing: 0.3px;
}
.doc-title-section {
  text-align: center;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-title {
  font-family: 'Noto Serif', serif;
  font-size: 24px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 8px;
}
.doc-title-ref {
  font-size: 13px;
  color: #666;
  margin: 0 0 4px;
}
.doc-title-date {
  font-size: 12px;
  color: #999;
  margin: 0 0 14px;
}
.doc-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 18px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.doc-status-badge.approved { background: #DCFCE7; color: #16A34A; border: 1px solid #86EFAC; }
.doc-status-badge.pending { background: #FEF9C3; color: #CA8A04; border: 1px solid #FDE047; }
.doc-status-badge.rejected { background: #FEE2E2; color: #DC2626; border: 1px solid #FCA5A5; }
.doc-status-badge.under_review { background: #DBEAFE; color: #2563EB; border: 1px solid #93C5FD; }
.doc-status-badge.sent_to_akagari { background: #DCFCE7; color: #16A34A; border: 1px solid #86EFAC; }
.doc-status-badge.sent_to_umudugudu { background: #DBEAFE; color: #1a3a5c; border: 1px solid #93C5FD; }
.doc-section {
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 8px 14px;
  background: #f1f5f9;
  border-left: 4px solid #1a3a5c;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.doc-section-title i { font-size: 14px; color: #d4a843; }
.doc-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
}
.doc-info-item {
  padding: 6px 0;
}
.doc-info-label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}
.doc-info-value {
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
}
.doc-description-box {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 16px;
  background: #fafbfc;
  line-height: 1.8;
  font-size: 14px;
  color: #1e293b;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.doc-evidence-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.doc-evidence-card {
  background: #fafbfc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
}
.doc-evidence-label {
  font-size: 10px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.doc-evidence-value {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
}
.doc-signature-area {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px;
  margin-top: 8px;
}
.doc-signature-box {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
  text-align: center;
  background: #fafbfc;
}
.doc-signature-box-title {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.doc-signature-box-content {
  min-height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.doc-signature-box-content img {
  max-height: 50px;
  display: block;
  border-radius: 3px;
  border: 1px solid #e2e8f0;
  padding: 3px;
  background: #fff;
}
.doc-signature-placeholder {
  width: 120px;
  height: 40px;
  border-bottom: 2px solid #ccc;
  margin: 0 auto 6px;
}
.doc-signature-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 4px;
}
.doc-signature-date {
  font-size: 10px;
  color: #999;
}
.doc-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 0 8px;
  position: relative;
  z-index: 1;
}
.doc-timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  position: relative;
  z-index: 2;
}
.doc-timeline-dot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #d1d5db;
  background: #fff;
  color: #d1d5db;
  position: relative;
  z-index: 2;
}
.doc-timeline-dot.completed {
  background: #16a34a;
  border-color: #16a34a;
  color: #fff;
}
.doc-timeline-dot.current {
  background: #1a3a5c;
  border-color: #1a3a5c;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(26,58,92,0.2);
}
.doc-timeline-label {
  font-size: 10px;
  font-weight: 600;
  color: #999;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.doc-timeline-label.completed { color: #16a34a; }
.doc-timeline-label.current { color: #1a3a5c; font-weight: 700; }
.doc-timeline-line {
  position: absolute;
  top: 17px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #e2e8f0;
  z-index: 1;
}
.doc-timeline-line.completed {
  background: #16a34a;
}
.doc-footer {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 2px solid #e2e8f0;
  text-align: center;
  position: relative;
  z-index: 1;
}
.doc-footer-republic {
  font-family: 'Noto Serif', serif;
  font-size: 14px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0 0 4px;
}
.doc-footer-text {
  font-size: 11px;
  color: #999;
  margin: 2px 0;
}
.doc-footer-divider {
  width: 60px;
  height: 2px;
  background: #d4a843;
  margin: 8px auto;
}
.doc-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}
.doc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  text-decoration: none;
  min-height: 42px;
}
.doc-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.doc-btn-primary {
  background: #1a3a5c;
  color: #fff;
}
.doc-btn-primary:hover:not(:disabled) { background: #0f2a45; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(26,58,92,0.3); }
.doc-btn-secondary {
  background: transparent;
  color: #1a3a5c;
  border: 1.5px solid #1a3a5c;
}
.doc-btn-secondary:hover { background: #eff6ff; }
.doc-btn-back {
  background: transparent;
  color: #475569;
  border: 1px solid #d1d9e6;
}
.doc-btn-back:hover { background: #f1f5f9; border-color: #94a3b8; }
.doc-verification-code {
  text-align: center;
  margin-top: 16px;
  padding: 8px 0;
  position: relative;
  z-index: 1;
}
.doc-verification-code span {
  font-size: 10px;
  color: #999;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;
  background: #f8fafc;
  padding: 4px 12px;
  border-radius: 3px;
  border: 1px dashed #ddd;
}

.coat-of-arms-svg {
  width: 56px;
  height: 56px;
}

@media (max-width: 768px) {
  .doc-paper { padding: 24px 20px; }
  .doc-header { padding-bottom: 20px; }
  .doc-header-right { position: static; text-align: center; margin-top: 12px; }
  .doc-title { font-size: 20px; }
  .doc-info-grid { grid-template-columns: 1fr; }
  .doc-evidence-grid { grid-template-columns: 1fr; }
  .doc-signature-area { grid-template-columns: 1fr 1fr; gap: 12px; }
  .doc-timeline { flex-wrap: wrap; gap: 8px; justify-content: center; }
  .doc-timeline-step { flex: 0 0 30%; }
}
@media (max-width: 480px) {
  .doc-paper { padding: 16px 14px; }
  .doc-header-republic { font-size: 15px; }
  .doc-title { font-size: 17px; }
  .doc-signature-area { grid-template-columns: 1fr; }
}

/* ── PRINT STYLES ── */
@media print {
  @page { margin: 20mm; size: A4; }
  body { background: #fff !important; margin: 0 !important; padding: 0 !important; }
  .doc-page { background: #fff !important; padding: 0 !important; min-height: auto !important; }
  .doc-paper {
    box-shadow: none !important;
    border-radius: 0 !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .doc-actions { display: none !important; }
  .no-print { display: none !important; }
  .doc-header { border-bottom-color: #1a3a5c !important; }
  .doc-header::after { background: #d4a843 !important; }
  .doc-section-title { border-left-color: #1a3a5c !important; background: #f1f5f9 !important; }
  .doc-title { color: #1a3a5c !important; }
  .doc-footer-republic { color: #1a3a5c !important; }
  .doc-footer-divider { background: #d4a843 !important; }
  .doc-status-badge,
  .doc-timeline-dot.completed,
  .doc-timeline-dot.current,
  .doc-timeline-line.completed { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  .coat-of-arms-svg { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
}
  `}</style>
);

export default function IbiregoAkagari() {
  const { toast } = useToast();
  const [allRecords, setAllRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortOrder, setSortOrder] = useState("newest");
  const [page, setPage] = useState(1);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const perPage = 10;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/isibo/ibirego`);
      setAllRecords(res.data || []);
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Habaye ikosa mu gupanga amakuru" });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const socket = io(SOCKET_URL, {
      auth: { token },
      transports: ["websocket", "polling"],
    });
    socket.on("connect", () => {});
    socket.on("isibo-ibirego-updated", () => {
      fetchData();
    });
    return () => { socket.disconnect(); };
  }, [fetchData]);

  const filteredRecords = useMemo(() => {
    let items = allRecords;
    if (search) {
      const q = search.toLowerCase();
      items = items.filter(
        (r) =>
          (r.complainant_name || "").toLowerCase().includes(q) ||
          (r.phone || "").toLowerCase().includes(q) ||
          (r.national_id || "").toLowerCase().includes(q) ||
          (r.izina_isibo || "").toLowerCase().includes(q)
      );
    }
    if (statusFilter !== "all") {
      items = items.filter((r) => r.status === statusFilter);
    }
    items = items.filter((r) => r.status === "sent_to_umudugudu" || r.status === "sent_to_akagari");
    items.sort((a, b) => {
      const da = new Date(a.created_at || 0).getTime();
      const db = new Date(b.created_at || 0).getTime();
      return sortOrder === "newest" ? db - da : da - db;
    });
    return items;
  }, [allRecords, search, statusFilter, sortOrder]);

  const totalPages = Math.max(1, Math.ceil(filteredRecords.length / perPage));
  const paginatedRecords = filteredRecords.slice((page - 1) * perPage, page * perPage);
  useEffect(() => { setPage(1); }, [search, statusFilter, sortOrder]);

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  const loadDetail = async (id) => {
    setDetailLoading(true);
    try {
      const res = await axios.get(`${API}/api/isibo/ibirego/${id}`);
      setSelectedDetail(res.data);
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Ntibashobotse gupanga amakuru" });
    } finally {
      setDetailLoading(false);
    }
  };

  const handleExportPDF = (d) => {
    const doc = new jsPDF();
    const refNumber = generateRefNumber(d.id);
    const today = new Date().toLocaleDateString("rw-RW", { year: "numeric", month: "long", day: "numeric" });

    let y = 15;

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("IBISOBANURO BY'ICYIREGO", 105, y, { align: "center" });
    y += 7;
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text(`Itariki yo gutanga: ${formatDate(d.created_at)}`, 105, y, { align: "center" });
    y += 3;
    doc.setDrawColor(200);
    doc.setLineWidth(0.3);
    doc.line(14, y + 2, 196, y + 2);
    y += 8;

    // Section 1: Complainant Info
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("1. AMAKURU Y'UWATANZE IKIREGO", 14, y);
    y += 7;

    const fields = [
      ["Amazina", d.complainant_name],
      ["Indangamuntu", d.national_id || "-"],
      ["Telephone", d.phone || "-"],
      ["Aho atuye", d.location || d.izina_isibo || "-"],
    ];

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    fields.forEach(([label, value]) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${label}:`, 14, y);
      doc.setFont("helvetica", "normal");
      doc.text(String(value), 70, y);
      y += 6;
    });
    y += 4;

    // Section 2: Description
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("2. IBISOBANURO BY'IKIREGO", 14, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    const descLines = doc.splitTextToSize(d.description || "Nta bisobanuro byatanzwe", 175);
    doc.text(descLines, 14, y);
    y += descLines.length * 5 + 6;

    // Section 3: Witnesses
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("3. AMAKURU Y'INYONGERAMUSARURO", 14, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    if (d.witnesses && d.witnesses.length > 0) {
      d.witnesses.forEach((w, i) => {
        doc.setFont("helvetica", "bold");
        doc.text(`Umuhamya ${i + 1}:`, 14, y);
        doc.setFont("helvetica", "normal");
        doc.text(w.witness_name, 55, y);
        y += 6;
      });
    } else {
      doc.text("Nta banyamuhamya bagaragajwe", 14, y);
      y += 6;
    }
    doc.text(`Isibo: ${d.izina_isibo || "-"}`, 14, y);
    y += 6;
    doc.text(`Icyoherejwe: ${d.sent_at ? formatDate(d.sent_at) : "Ntibyoherejwe"}`, 14, y);
    y += 8;

    // Section 4: Signatures
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("4. UMWANYA W'UMUKONO", 14, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    if (d.signatures && d.signatures.length > 0) {
      d.signatures.forEach((sig) => {
        doc.setFont("helvetica", "bold");
        doc.text(`Uwatanze Ikirego:`, 14, y);
        doc.setFont("helvetica", "normal");
        doc.text(`${sig.signed_by} - ${sig.signed_at ? formatDate(sig.signed_at) : ""}`, 55, y);
        y += 6;
      });
    } else {
      doc.text("Uwatanze Ikirego: (ntiyasinye)", 14, y);
      y += 6;
    }

    if (d.umudugudu_signatures && d.umudugudu_signatures.length > 0) {
      d.umudugudu_signatures.forEach((ms) => {
        doc.setFont("helvetica", "bold");
        doc.text(`Ushinzwe Umutekano:`, 14, y);
        doc.setFont("helvetica", "normal");
        doc.text(`${ms.umudugudu_name} - ${ms.signed_at ? formatDate(ms.signed_at) : ""}`, 55, y);
        y += 6;
      });
    } else {
      doc.text("Ushinzwe Umutekano: (ntiyasinye)", 14, y);
      y += 6;
    }

    // Timeline
    y += 4;
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Iterambere ry'Ikirego", 14, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    const steps = ["Byatanzwe", "Byakiriwe", "Burebwa", "Byakozwe", "Byafunzwe"];
    const stepX = [14, 50, 86, 122, 158];
    steps.forEach((s, i) => {
      doc.setDrawColor(0, 91, 172);
      doc.circle(stepX[i] + 10, y + 3, 3, "F");
      doc.setFont("helvetica", "bold");
      doc.text(s, stepX[i], y + 10);
    });
    y += 16;

    doc.save(`icyirego_${d.id}.pdf`);
  };

  const getStatusConfig = (status) => {
    const configs = {
      approved: { label: "Byemejwe", cls: "approved" },
      pending: { label: "Itegereje", cls: "pending" },
      rejected: { label: "Byanzwe", cls: "rejected" },
      under_review: { label: "Burebwa", cls: "under_review" },
      sent_to_akagari: { label: "Yoherejwe ku Kagari", cls: "sent_to_akagari" },
      sent_to_umudugudu: { label: "Yoherejwe ku Mudugudu", cls: "sent_to_umudugudu" },
    };
    return configs[status] || { label: status?.replace(/_/g, " ") || "Itegereje", cls: "pending" };
  };

  const timelineSteps = [
    { key: "submitted", label: "Byatanzwe" },
    { key: "received", label: "Byakiriwe" },
    { key: "under_review", label: "Burebwa" },
    { key: "processed", label: "Byakozwe" },
    { key: "closed", label: "Byafunzwe" },
  ];

  const getStepStatus = (stepKey, currentStatus) => {
    const order = ["submitted", "received", "under_review", "processed", "closed"];
    const statusOrder = {
      pending: 0,
      sent_to_umudugudu: 1,
      signed: 1,
      sent_to_akagari: 2,
      approved: 3,
      rejected: 3,
      closed: 4,
    };
    const currentIdx = statusOrder[currentStatus] ?? 0;
    const stepIdx = order.indexOf(stepKey);
    if (stepIdx < currentIdx) return "completed";
    if (stepIdx === currentIdx) return "current";
    return "";
  };

  const generateRefNumber = (id) => {
    const prefix = "RWA-CCMS";
    const date = new Date();
    const yr = date.getFullYear();
    const seq = String(id || 0).padStart(5, "0");
    return `${prefix}-${yr}-${seq}`;
  };

  const generateVerificationCode = (id) => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    for (let i = 0; i < 12; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return `VER-${code}-${String(id || 0).slice(-3)}`;
  };

  const handlePrint = () => {
    window.print();
  };

  const RwandaCoatOfArms = () => (
    <svg className="coat-of-arms-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="none" stroke="#005BAC" strokeWidth="1.5" />
      <circle cx="50" cy="52" r="20" fill="#FAD201" opacity="0.3" />
      <circle cx="50" cy="52" r="14" fill="#FAD201" opacity="0.5" />
      <circle cx="50" cy="52" r="8" fill="#FAD201" />
      {[0,45,90,135,180,225,270,315].map((angle, i) => (
        <line key={i} x1="50" y1="52" x2={50 + 22 * Math.cos(angle * Math.PI / 180)} y2={52 + 22 * Math.sin(angle * Math.PI / 180)} stroke="#FAD201" strokeWidth="2" opacity="0.6" />
      ))}
      <path d="M34 58 Q42 72 58 72 Q66 58 58 58 Q50 64 42 58 Z" fill="#005BAC" />
      <rect x="38" y="72" width="24" height="6" rx="1" fill="#8B4513" />
      <path d="M32 80 Q50 88 68 80" fill="none" stroke="#228B22" strokeWidth="2" />
      <path d="M28 82 Q20 76 18 70" fill="none" stroke="#228B22" strokeWidth="2" />
      <path d="M72 82 Q80 76 82 70" fill="none" stroke="#228B22" strokeWidth="2" />
      <text x="50" y="20" textAnchor="middle" fontSize="5" fontWeight="700" fill="#005BAC">UBUMWE</text>
      <text x="50" y="26" textAnchor="middle" fontSize="5" fontWeight="700" fill="#005BAC">UMURIMO</text>

    </svg>
  );

  const QRCodeSVG = ({ value, size }) => (
    <svg width={size || 70} height={size || 70} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" fill="#fff" rx="2" />
      <g fill="#005BAC">
        {[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69].map(i => {
          const x = i % 70;
          const y = Math.floor(i / 70);
          if ((x < 14 && y < 14) || (x > 55 && y < 14) || (x < 14 && y > 55)) {
            if ((x < 7 && y < 7) || (x > 62 && y < 7) || (x < 7 && y > 62)) return <rect key={i} x={x} y={y} width="1" height="1" fill="#005BAC" />;
            if (x >= 7 && x < 14 && y >= 7 && y < 14) return null;
            if (x >= 56 && x < 63 && y >= 7 && y < 14) return null;
            if (x >= 7 && x < 14 && y >= 56 && y < 63) return null;
            return null;
          }
          return null;
        })}
        <rect x="3" y="3" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
        <rect x="59" y="3" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
        <rect x="3" y="59" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
      </g>
    </svg>
  );

  if (selectedDetail) {
    const d = selectedDetail;
    const statusCfg = getStatusConfig(d.status);
    const refNumber = generateRefNumber(d.id);
    const verificationCode = generateVerificationCode(d.id);
    const qrData = `RWA-CCMS:${refNumber}:VER:${verificationCode}`;
    const today = new Date().toLocaleDateString("rw-RW", { year: "numeric", month: "long", day: "numeric" });

    return (
      <>
        <Styles />
        <div className="doc-page no-print">
          <div className="doc-actions">
            <button className="doc-btn doc-btn-back" onClick={() => setSelectedDetail(null)}>
              <i className="bi bi-arrow-left" /> Subira
            </button>
            <button className="doc-btn doc-btn-secondary" onClick={handlePrint}>
              <i className="bi bi-printer" /> Iwandike
            </button>
            <button className="doc-btn doc-btn-primary" onClick={() => handleExportPDF(d)}>
              <i className="bi bi-file-pdf" /> PDF
            </button>
          </div>
        </div>

        <div className="doc-page" id="akagari-document-content">
          <div className="doc-paper">
            <div className="doc-watermark">REPUBULIKA Y'U RWANDA</div>

            {/* ── OFFICIAL HEADER ── */}
            <div className="doc-header">
              <div className="doc-header-left">
                <RwandaCoatOfArms />
              </div>
              <div className="doc-header-center">
                <p className="doc-header-republic">Repubulika y'u Rwanda</p>
                <p className="doc-header-ministry">Minisiteri y'Ubutegetsi bw'Igihugu</p>
                <p className="doc-header-system">Inkingi | Village Management System</p>
              </div>
              <div className="doc-header-right">
                <QRCodeSVG value={qrData} size={65} />
                <div className="doc-tracking">Ver: {verificationCode}</div>
              </div>
            </div>

            {/* ── REFERENCE ── */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, position: "relative", zIndex: 1 }}>
              <span className="doc-ref-number">Ref: {refNumber}</span>
              <span className="doc-ref-number">Itariki: {today}</span>
            </div>

            {/* ── DOCUMENT TITLE ── */}
            <div className="doc-title-section">
              <h1 className="doc-title">Ibisobanuro by'Icyirego</h1>
              <p className="doc-title-ref">Icyirego cyoherejwe binyuze muri sisitemu</p>
              <p className="doc-title-date">Itariki yo gutanga: {formatDate(d.created_at)}</p>
              <span className={`doc-status-badge ${statusCfg.cls}`}>
                <i className={`bi ${d.status === "sent_to_akagari" ? "bi-check-circle" : "bi-clock"}`} />
                {statusCfg.label}
              </span>
            </div>

            {/* ── SECTION 1: AMAKURU Y'UWATANZE IKIREGO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-person-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Amakuru y'Uwatanze Ikirego
              </h2>
              <div className="doc-info-grid">
                <div className="doc-info-item">
                  <div className="doc-info-label">Amazina</div>
                  <div className="doc-info-value">{d.complainant_name}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Indangamuntu</div>
                  <div className="doc-info-value">{d.national_id || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Telephone</div>
                  <div className="doc-info-value">{d.phone || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Aho atuye</div>
                  <div className="doc-info-value">{d.location || d.izina_isibo || "-"}</div>
                </div>
              </div>
            </div>

            {/* ── SECTION 2: IBISOBANURO BY'IKIREGO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-file-text-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Ibisobanuro by'Ikirego
              </h2>
              <div className="doc-description-box">
                {d.description || "Nta bisobanuro byatanzwe"}
              </div>
            </div>

            {/* ── SECTION 3: AMAKURU Y'INYONGERAMUSARURO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-people-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Amakuru y'Inyongeramusaruro
              </h2>

              {d.witnesses && d.witnesses.length > 0 ? (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                    <i className="bi bi-person-check-fill" style={{ color: "#005BAC", fontSize: 14 }} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Abanyamuhamya</span>
                  </div>
                  <div className="doc-evidence-grid">
                    {d.witnesses.map((w, i) => (
                      <div key={w.id || i} className="doc-evidence-card" style={{ borderLeft: "4px solid #005BAC" }}>
                        <div className="doc-evidence-label">Umuhamya {i + 1}</div>
                        <div className="doc-evidence-value" style={{ marginBottom: 4, fontSize: 15 }}>{w.witness_name}</div>
                        {w.signed_at && (
                          <>
                            <div className="doc-evidence-label" style={{ marginTop: 8 }}>Itariki</div>
                            <div className="doc-evidence-value" style={{ fontSize: 13 }}>{formatDate(w.signed_at)}</div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="doc-evidence-card" style={{ padding: "14px 16px", marginBottom: 4, borderLeft: "4px solid #94a3b8" }}>
                  <div className="doc-evidence-value" style={{ color: "#888", fontSize: 13 }}>Nta banyamuhamya bagaragajwe</div>
                </div>
              )}

              <div className="doc-info-grid" style={{ marginTop: 16, paddingTop: 16, borderTop: "1px dashed #E2E8F0" }}>
                <div className="doc-info-item">
                  <div className="doc-info-label">Isibo</div>
                  <div className="doc-info-value">{d.izina_isibo || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Icyoherejwe</div>
                  <div className="doc-info-value">{d.sent_at ? formatDate(d.sent_at) : "Ntibyoherejwe"}</div>
                </div>
              </div>
            </div>

            {/* ── SECTION 4: UMWANYA W'UMUKONO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-pen-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Umwanya w'Umukono
              </h2>
              <div className="doc-signature-area">
                <div className="doc-signature-box" style={{ borderTop: "3px solid #005BAC" }}>
                  <div className="doc-signature-box-title">Uwatanze Ikirego</div>
                  <div className="doc-signature-box-content">
                    {d.signatures && d.signatures.length > 0 ? (
                      d.signatures.map((sig, i) => (
                        <div key={sig.id || i}>
                          {sig.signature_image && <img src={sig.signature_image} alt="Umukono" style={{ maxHeight: 55 }} />}
                          <div style={{ width: "100%", height: 2, background: "#005BAC", margin: "6px 0" }} />
                          <div className="doc-signature-name">{sig.signed_by}</div>
                          <div className="doc-signature-date">{sig.signed_at ? formatDate(sig.signed_at) : ""}</div>
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="doc-signature-placeholder" />
                        <div className="doc-signature-date">Umukono</div>
                      </>
                    )}
                  </div>
                </div>

                <div className="doc-signature-box" style={{ borderTop: "3px solid #20603D" }}>
                  <div className="doc-signature-box-title">Ushinzwe Umutekano</div>
                  <div className="doc-signature-box-content">
                    {d.umudugudu_signatures && d.umudugudu_signatures.length > 0 ? (
                      d.umudugudu_signatures.map((ms, i) => (
                        <div key={ms.id || i}>
                          {ms.signature_image && <img src={ms.signature_image} alt="Umukono" style={{ maxHeight: 55 }} />}
                          <div style={{ width: "100%", height: 2, background: "#20603D", margin: "6px 0" }} />
                          <div className="doc-signature-name">{ms.umudugudu_name}</div>
                          <div className="doc-signature-date">{ms.signed_at ? formatDate(ms.signed_at) : ""}</div>
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="doc-signature-placeholder" />
                        <div className="doc-signature-date">Umukono</div>
                      </>
                    )}
                  </div>
                </div>

                <div className="doc-signature-box" style={{ borderTop: "3px solid #F59E0B" }}>
                  <div className="doc-signature-box-title">Umukono wa Digitari</div>
                  <div className="doc-signature-box-content">
                    <div style={{ width: 60, height: 60, borderRadius: "50%", border: "3px solid #005BAC", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 8px", background: "#EFF6FF" }}>
                      <i className="bi bi-shield-fill-check" style={{ fontSize: 28, color: "#005BAC" }} />
                    </div>
                    <div className="doc-signature-name" style={{ fontSize: 11, color: "#005BAC" }}>Digital Signature</div>
                    <div style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 10px", background: "#DCFCE7", borderRadius: 10, fontSize: 10, fontWeight: 600, color: "#16A34A", marginTop: 4 }}>
                      <i className="bi bi-patch-check-fill" /> Verified
                    </div>
                  </div>
                </div>
              </div>

              {d.sent_to_akagari_at && (
                <div style={{ marginTop: 16, padding: "10px 16px", background: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: 8, textAlign: "center", position: "relative", zIndex: 1 }}>
                  <i className="bi bi-check-circle-fill" style={{ color: "#16A34A", marginRight: 6 }} />
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#15803D" }}>
                    Icyirego cyoherejwe ku Kagari: {formatDate(d.sent_to_akagari_at)}
                  </span>
                </div>
              )}
            </div>

            {/* ── STATUS TIMELINE ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-graph-up-arrow" style={{ marginRight: 8, fontSize: 14 }} />
                Inkingi y'Iterambere ry'Ikirego
              </h2>
              <div className="doc-timeline">
                <div className="doc-timeline-line" />
                <div className="doc-timeline-line completed" style={{ width: `${(timelineSteps.findIndex(s => getStepStatus(s.key, d.status) === "current") >= 0 ? timelineSteps.findIndex(s => getStepStatus(s.key, d.status) === "current") : 0) / (timelineSteps.length - 1) * 100}%` }} />
                {timelineSteps.map((step, idx) => {
                  const stepStatus = getStepStatus(step.key, d.status);
                  return (
                    <div key={step.key} className="doc-timeline-step">
                      <div className={`doc-timeline-dot ${stepStatus}`}>
                        {stepStatus === "completed" ? <i className="bi bi-check" style={{ fontSize: 16 }} /> : stepStatus === "current" ? <i className="bi bi-circle-fill" style={{ fontSize: 8 }} /> : idx + 1}
                      </div>
                      <div className={`doc-timeline-label ${stepStatus}`}>{step.label}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── VERIFICATION ── */}
            <div className="doc-verification-code">
              <span>Inyandiko y'ubutumwa: {verificationCode}</span>
            </div>

            {/* ── OFFICIAL FOOTER ── */}
            <div className="doc-footer">
              <div className="doc-footer-divider" />
              <p className="doc-footer-republic">Repubulika y'u Rwanda</p>
              <p className="doc-footer-text">Inkingi - Sisitemu yo Gucunga neza Imirimo</p>
              <p className="doc-footer-text" style={{ fontSize: 9 }}>Iyi nyandiko yakozwe kuri sisitemu ya Inkingi | © {new Date().getFullYear()}</p>
            </div>

          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Styles />
      <div className="ia-container">
        <div className="ia-header-card">
          <h2><i className="bi bi-file-earmark-text" /> IBIREGO</h2>
          <p>Ibirego byoherejwe mu Kagari bivuye mu Mudugudu</p>
        </div>

        <div className="ia-controls">
          <div className="ia-search">
            <i className="bi bi-search" />
            <input
              type="text"
              placeholder="Shakisha ku mazina, telephone, indangamuntu, isibo..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: 0 }}
              >
                <i className="bi bi-x-lg" />
              </button>
            )}
          </div>
          <select className="ia-filter-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">Status yose</option>
            <option value="sent_to_umudugudu">Itegereje</option>
            <option value="sent_to_akagari">Yoherejwe mu Kagari</option>
          </select>
          <select className="ia-filter-select" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="newest">Bishya ku Ikarabuye</option>
            <option value="oldest">Bikera ku Ikarabuye</option>
          </select>
        </div>

        <div className="ia-table-card">
          <div className="ia-info-bar">
            <span><i className="bi bi-funnel" /> {filteredRecords.length} records</span>
          </div>
          <div className="ia-table-scroll">
            <table className="ia-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Amazina y'Uwatanze Ikirego</th>
                  <th>Telephone</th>
                  <th>Isibo</th>
                  <th>Ibisobanuro</th>
                  <th>Itariki</th>
                  <th>Status</th>
                  <th>Ibikorwa</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={8} data-label="" style={{ textAlign: "center", padding: 40, color: "#64748b" }}>Bitegereza...</td></tr>
                ) : paginatedRecords.length === 0 ? (
                  <tr><td colSpan={8} data-label="">
                    <div className="ia-empty-state">
                      <i className="bi bi-inbox" />
                      <p>Nta birego byoherejwe mu Kagari</p>
                    </div>
                  </td></tr>
                ) : (
                  paginatedRecords.map((r) => (
                    <tr key={r.id}>
                      <td data-label="#" style={{ color: "#64748b" }}>#{r.id}</td>
                      <td data-label="Amazina" style={{ fontWeight: 600, color: "#1e293b" }}>{r.complainant_name}</td>
                      <td data-label="Telephone">{r.phone || "-"}</td>
                      <td data-label="Isibo">{r.izina_isibo}</td>
                      <td data-label="Ibisobanuro" style={{ maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.description}</td>
                      <td data-label="Itariki" style={{ fontSize: "0.75rem", color: "#64748b" }}>{formatDate(r.created_at)}</td>
                      <td data-label="Status">
                        <span className={`ia-status ${r.status === "sent_to_akagari" ? "ia-status-sent" : "ia-status-pending"}`}>
                          <i className={`bi ${r.status === "sent_to_akagari" ? "bi-check-circle" : "bi-clock"}`} />
                          {r.status === "sent_to_akagari" ? "Mu Kagari" : "Itegereje"}
                        </span>
                      </td>
                      <td data-label="">
                        <button
                          onClick={() => loadDetail(r.id)}
                          style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "6px 12px", background: "#003366", color: "#fff", border: "none", borderRadius: 6, fontSize: "0.75rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit", width: "100%", justifyContent: "center" }}
                        >
                          <i className="bi bi-eye" /> Reba
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="ia-pagination">
              <button className="ia-page-btn" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
                <i className="bi bi-chevron-left" />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                <button
                  key={pg}
                  className={`ia-page-btn ${page === pg ? "active" : ""}`}
                  onClick={() => setPage(pg)}
                >
                  {pg}
                </button>
              ))}
              <button className="ia-page-btn" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
